import React, { ReactElement } from 'react';

import { Container, List, ListItem, Text } from '@constellation/core';
import NeedHelpWrapper from 'components/needHelpWrapper/NeedHelpWrapper';
import { Accordion } from 'components/tagging';

import { ACCORDION_EVENTS } from '../../../constants/analytics.constants';
import getLabel from '../../../utils/getLabel';

// This component will render when the user is not a full power signatory
function NeedHelp(): ReactElement {
  return (
    <Container padding="none">
      <NeedHelpWrapper>
        <Accordion
          label={getLabel('needHelp.fullAccessUser.title')}
          variation="standalone"
          className="accordian_label"
          eventAction={ACCORDION_EVENTS.FULL_ACCESS_USER_PERMISSIONS}
          marginBottom="02"
        >
          <Text>{getLabel('needHelp.fullAccessUser.list.header')}</Text>
          <List marginBottom="none" marginLeft="02">
            {getLabel('needHelp.fullAccessUser.list.listItems').map(
              ({ id, content }) => (
                <ListItem key={id}>
                  <Text>{content}</Text>
                </ListItem>
              ),
            )}
          </List>
        </Accordion>
      </NeedHelpWrapper>
    </Container>
  );
}

export default NeedHelp;
